/*
    https://growth.design/sniper-link
*/
export const createSniperLink = ({ email }: { email: string }) => {
  return `https://mail.google.com/mail/u/${email}/#search/from%3A%40codelex+in%3Aanywhere+newer_than%3A12h`;
};
